import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Chevron from '../../resources/icons/chevron.svg';
import css from './ExpandButton.css';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';

const ExpandButton = forwardRef(
    (
        {
            containerClass = '',
            containerStyle = {},
            icon = '',
            text = '',
            hide = false,
            onClick = () => {},
            isClicked = false,
            isExpanded: isOpen = false,
            disabled = false,
        },
        ref
    ) => {
        const [isExpanded, setIsExpanded] = useState(isOpen);

        useEffect(() => {
            setIsExpanded(isOpen);
        }, [isOpen]);

        const onExpandClicked = () => {
            setIsExpanded(prev => prev);
            onClick(!isExpanded);
        };

        if (hide) return null;

        return (
            <div
                ref={ref}
                className={classNames(css.container, containerClass, {
                    [css.clicked]: isExpanded || isClicked,
                    [css.disabled]: disabled,
                })}
                style={containerStyle}
                onClick={onExpandClicked}
            >
                <div className={css.textContainer}>
                    {icon && (
                        <Icon name={icon} variant={IconVariants.ACTIVE} disabled={disabled} size={IconSizes.MEDIUM} />
                    )}
                    <span>{text}</span>
                </div>
                <div className={css.expandContainer}>
                    <Chevron className={classNames(css.icon, { [css.top]: isExpanded })} />
                </div>
            </div>
        );
    }
);

ExpandButton.propTypes = {
    containerClass: PropTypes.string,
    containerStyle: PropTypes.objectOf(PropTypes.any),
    icon: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hide: PropTypes.bool,
    onClick: PropTypes.func,
    isClicked: PropTypes.bool,
    isExpanded: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default ExpandButton;
